import React from 'react'
import Sidebar from '../../components/sidebar'

const Wallet = () => {
    return <div></div>
}

export default Wallet
